import { BorderColor, colorsToBorderColorClass } from "components/DesignSystem"

/**
 *  A class that determines the border color class based on the passed border
 *  color.
 */
export function determineBorderColorClass(designator: BorderColor) {
  return colorsToBorderColorClass[designator]
}
